/**
 * import and init third party
 * components/validators and other dependencies
 */

import { extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import moment from 'moment'
import isEmpty from 'lodash/isEmpty'
// eslint-disable-next-line no-useless-escape
var re =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const regexUsername =
  /^[a-zA-Z_ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂ ưăạảấầẩẫậắằẳẵặẹếẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/
const regexNumber = /^[0-9]+$/
// const regexMobile = /^((09|03|07|08|05)+([0-9]{8,9})\b)$/
const regexMobile = /^0\d{9,13}$/
const regexEmail =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
// const regexMobile = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/

// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

extend('required', value => {
  if (typeof value === 'object') {
    if (value instanceof Date) return true
    return isEmpty(value) ? '{_field_} không được để trống' : true
  } else if (value) {
    return true
  }

  return '{_field_} không được để trống'
})

extend('username', value => {
  const check = regexUsername.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }

  return '{_field_} bắt buộc nhập'
})

extend('minMAxName', value => {
  if (value.length > 3 && value.length < 255) {
    return true
  }
  return '{_field_} ít nhất là 3 ký tự và nhiều nhất 255 ký tự'
})

extend('minMaxKpi', value => {
  if (value > 0 && value <= 2) {
    return true
  }
  return '{_field_} số KPI phải lớn hơn 0 và nhỏ hơn 2'
})

extend('mail', value => {
  if (value.length < 3 && value.length > 255) {
    return '{_field_} được nhập tối đa 255 ký tự'
  }
  const check = re.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('regexNumber', value => {
  const check = regexNumber.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} chỉ được nhập số'
  }
  if (check) {
    return true
  }
})

extend('regexNumber1', value => {
  const check = regexNumber.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} chỉ được nhập số'
  }
  if (value > 3 || value < 1) {
    return '{_field_} chỉ được nhập số 1/2/3'
  }
  if (check) {
    return true
  }
})

extend('maxLength', value => {
  if (value.length <= 20) {
    return true
  }
  return '{_field_} được nhập tối đa 20 ký tự'
})

extend('phoneRex', value => {
  if (value.length > 50) {
    return '{_field_} được nhập tối đa 50 kí tự'
  }
  if (value.length > 1 && value.length < 50) {
    return true
  }
  return '{_field_} là bắt buộc nhập'
})

extend('phoneLimit', value => {
  if (value.length >= 50) {
    return '{_field_} tối đa 50 kí tự'
  }
  if (value.length > 1 && value.length < 50) {
    return true
  }
})

extend('requiredDate', value => {
  if (value.startDate && value.endDate) {
    return true
  }

  return '{_field_} là bắt buộc nhập'
})
extend('dateRangeInOneDay', value => {
  const start = moment(value.startDate).format('L')
  const end = moment(value.endDate).format('L')
  if (start !== end) return 'Thời gian bắt đầu và kết thúc phải trong cùng một ngày'
  else return true
})

extend('minMAxAgentName', value => {
  if (value.length > 2 && value.length < 50) {
    return true
  }
  return '{_field_} Ký tự nhỏ nhất là 2 và lớn nhất 50 ký tự'
})

extend('regexMobile', value => {
  const check = regexMobile.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('emailOrPhone', value => {
  const isEmail = regexEmail.test(String(value).toLowerCase())
  const isPhone = /^0\d+$/.test(String(value))
  if (isEmail || isPhone) {
    return true
  }
  return '{_field_} không đúng định dạng email hoặc số điện thoại (phải bắt đầu bằng số 0)'
})

extend('serialPR02', value => {
  const check = String(value).substr(0, 4) === 'MPOS' && !String(value).includes(' ')
  if (!check) {
    return '{_field_} không đúng quy định'
  }
  if (check) {
    return true
  }
})

extend('serialSmartPOS', value => {
  const check = String(value).substr(0, 2) === 'SP' && !String(value).includes(' ')
  if (!check) {
    return '{_field_} không đúng quy định'
  }
  if (check) {
    return true
  }
})

extend('serialRest', value => {
  const check = !String(value).includes(' ')
  if (!check) {
    return '{_field_} không đúng quy định'
  }
  if (check) {
    return true
  }
})

// extend('between', {
//   params: ['min', 'max'],
//   validate (value, { min, max }) {
//     return value.length >= min && value.length <= max
//   },
//   message: '{_field_} được nhập từ {min} đến {max} ký tự'
// })

// extend('maxLength', {
//   params: ['max'],
//   validate (value, { max }) {
//     return value.length <= max
//   },
//   message: '{_field_} được nhập tối đa {max} ký tự'
// })

extend('minMaxName_1', value => {
  if (value.length <= 1000) {
    return true
  }
  return '{_field_} chỉ được nhập tối đa 1000 ký tự'
})

extend('minMaxName_2', value => {
  if (value.length >= 2 && value.length <= 100) {
    return true
  }
  return '{_field_} chỉ được nhập từ 2 đến 100 ký tự'
})

extend('minMaxName_3', value => {
  if (value.length >= 2 && value.length <= 255) {
    return true
  }
  return '{_field_} chỉ được nhập từ 2 đến 255 ký tự'
})

extend('minMaxName_4', value => {
  if (value.length <= 500) {
    return true
  }
  return '{_field_} được nhập tối đa 500 ký tự'
})

extend('minMaxName_5', value => {
  if (value.length >= 3 && value.length <= 100) {
    return true
  }
  return '{_field_} chỉ được nhập từ 3 đến 100 ký tự'
})

extend('minMaxName_6', value => {
  if (value.length <= 250) {
    return true
  }
  return '{_field_} chỉ được nhập tối đa 250 ký tự'
})

extend('minMaxName_7', value => {
  if (value.length <= 100) {
    return true
  }
  return '{_field_} chỉ được nhập tối đa 100 ký tự'
})

extend('name4', value => {
  if (value.length >= 2 && value.length <= 2000) {
    return true
  }
  return '{_field_} chỉ được nhập từ 2 đến 2000 ký tự'
})

extend('maxReceipt_2', value => {
  if (value.length >= 0 && value.length <= 255) {
    return true
  }
  return '{_field_} được nhập tối đa là 255 ký tự'
})

extend('note_1000', value => {
  if (value.length >= 2 && value.length <= 1000) {
    return true
  }
  return '{_field_} chỉ được nhập từ 2 đến 1000 ký tự'
})

extend('maxReceipt_3', value => {
  if (value.length > 0 && value.length <= 255) {
    return true
  }
  return '{_field_} ký tự nhỏ nhất là 1 và lớn nhất là 255 ký tự'
})

extend('mail_1', value => {
  if (value.length > 20) {
    return '{_field_} tối đa 20 ký tự'
  }
  const check = regexEmail.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('mail_2', value => {
  if (value.length < 2 && value.length > 100) {
    return '{_field_} Ký tự nhỏ nhất là 2 và lớn nhất 100 ký tự'
  }
  const check = regexEmail.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('mail_3', value => {
  if (value.length < 2) {
    return '{_field_} phải điền ít nhất 2 ký tự'
  }
  const check = regexEmail.test(String(value).toLowerCase())
  if (!check) {
    return '{_field_} không đúng định dạng'
  }
  if (check) {
    return true
  }
})

extend('inputLimit50', value => {
  if (value.length >= 50) {
    return '{_field_} tối đa 50 kí tự'
  }
  if (value.length <= 1) {
    return '{_field_} ít nhất 2 kí tự'
  }
  if (value.length > 1 && value.length < 50) {
    return true
  }
})

extend('numberCheck', value => {
  if (Number(value) === 0) {
    return '{_field_} phải lớn hơn 0'
  } else {
    return true
  }
})
extend('numberCheck_1', value => {
  if (Number(value) <= 0) {
    return '{_field_} phải lớn hơn 0'
  } else {
    return true
  }
})

extend('codeGroupTicket', value => {
  if (/[^\w\sÀ-ỹ]/g.test(value)) {
    return '{_field_} không chứa kí tự đặc biệt'
  }
  if (/[a-z]/.test(value)) {
    return '{_field_} không chứa chữ in thường'
  }
  if (value.length >= 50) {
    return '{_field_} tối đa 50 kí tự'
  } else {
    return true
  }
})
// extend('required_1', value => {
//     if (value === false) {
//         return true
//     }
//     else if (value == undefined || value == null || value == '') {
//       return '{_field_} không được để trống'
//     }
//     else if (value) {
//         return '{_field_} không được để trống'
//     }
//     return '{_field_} không được để trống'
// })

extend('regexNumber2', value => {
  const check = /^[0-9]+(\.[0-9]+)?$/.test(value)
  if (!check) {
    return '{_field_} không đúng định dạng (VD: 2.25)'
  }
  if (check) {
    return true
  }
})

extend('receiptTransactionCode', {
  params: ['target'],
  validate(value, { target }) {
    // CUSTOMER_CARD | SALE_CARD | CUSTOMER_TRANSFER
    if (target === 'CUSTOMER_TRANSFER') {
      // "IBSML247/" Tiền tố cố định +7 chữ số đằng sau
      if (/^IBSML247\/\d{7}$/.test(value)) {
        return true // Pass validation
      } else {
        return 'Vui lòng nhập theo định dạng "IBSML247/" + 7 chữ số'
      }
    } else {
      // Cố định 20 ký tự số
      if (/^\d{20}$/.test(value)) {
        return true // Pass validation
      } else {
        return 'Vui lòng nhập 20 ký tự số'
      }
    }
  },
})

extend('max30Character', value => {
  if (value.length <= 30) {
    return true
  }
  return `{_field_} được nhập tối đa 30 ký tự`
})
